/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} openDishModalParams
* @property {string} dishId - dish ID
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} origin - menu/cart
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Open dish modal. Evid: 801.
 * Event description: OLO- UoU opened dish modal (Click on dish, dish modal has been opened).

 * dishId - Type: string. Desc: dish ID
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: menu/cart
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {openDishModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openDishModal = function (params) {
    return { evid: 801, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} restaurantsOloUouServiceFeeFailureWebParams
* @property {string} error - -
* @property {GUID} locationGuid - null
* @property {string} requestName - "listRules" | "calculateServiceFees" | "listRestaurantLocations"
**/
/**
 * Name: Restaurants > OLO > UoU> Service fee failure (web). Evid: 892.
 * Event description: when service fees calculations are failing.

 * error - Type: string. Desc: -
 *
 * locationGuid - Type: guid.
 *
 * requestName - Type: string. Desc: "listRules" | "calculateServiceFees" | "listRestaurantLocations"
 * @param {restaurantsOloUouServiceFeeFailureWebParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsOloUouServiceFeeFailureWeb = function (params) {
    return { evid: 892, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartAddOrderNotesParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Add Order Notes. Evid: 829.
 * Event description: OLO- In the Cart, the UoU clicked on "Add Order Notes "- AKA the UoU will add a comment (Not yet added).

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartAddOrderNotesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartAddOrderNotes = function (params) {
    return { evid: 829, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutReviewPoliciesParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} type - privacyPolicy/termsAndConditions
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Review -> Policies. Evid: 832.
 * Event description: UoU clicked on the termsAndConditions/privacyPolicy in the "Review and Place Order" stage in the checkout..

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * type - Type: string. Desc: privacyPolicy/termsAndConditions
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {checkoutReviewPoliciesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutReviewPolicies = function (params) {
    return { evid: 832, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutInformativeMessageParams
* @property {string} checkoutStep - delivery method/contact/ payment..
* @property {GUID} locationGuid - .
* @property {string} messageType - which feature this message belongs to
* @property {string} messageValue - The content of the message
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - null
* @property {string} viewMode - Preview/liveSite
**/
/**
 * Name: Checkout->informative message. Evid: 882.
 * Event description: OLO-  Checkout page load after UoU clicked on Go to Checkout.

 * checkoutStep - Type: string. Desc: delivery method/contact/ payment..
 *
 * locationGuid - Type: guid. Desc: .
 *
 * messageType - Type: string. Desc: which feature this message belongs to
 *
 * messageValue - Type: string. Desc: The content of the message
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string.
 *
 * viewMode - Type: string. Desc: Preview/liveSite
 * @param {checkoutInformativeMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutInformativeMessage = function (params) {
    return { evid: 882, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addressInformationContinueValidationErrorParams
* @property {string} comment - comment
* @property {GUID} configurationId - configurationId
* @property {DateTime} dispatchTime - delivery/pickup hour
* @property {string} dispatchTimeOption - asap/later
* @property {string} dispatchType - delivery/pickup/dine-in
* @property {string} errorReason - deliveryAddress/apt/floor/entrance/
contactlessDineInInputLabel concat between them
* @property {GUID} integrationAppId - integrationAppId
* @property {string} integrationName - doordash/uber_eats/etc...
* @property {boolean} isContactless - true/false
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} pageName - checkout/ dispatch modal
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Address information continue- validation error. Evid: 813.
 * Event description: OLO- UoU clicked on the continue button - continue from address information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue). (the page_name column was added in Aug 21).

 * comment - Type: string. Desc: comment
 *
 * configurationId - Type: guid. Desc: configurationId
 *
 * dispatchTime - Type: datetime. Desc: delivery/pickup hour
 *
 * dispatchTimeOption - Type: string. Desc: asap/later
 *
 * dispatchType - Type: string. Desc: delivery/pickup/dine-in
 *
 * errorReason - Type: string. Desc: deliveryAddress/apt/floor/entrance/
contactlessDineInInputLabel concat between them
 *
 * integrationAppId - Type: guid. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordash/uber_eats/etc...
 *
 * isContactless - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * pageName - Type: string. Desc: checkout/ dispatch modal
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {addressInformationContinueValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addressInformationContinueValidationError = function (params) {
    return { evid: 813, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dashboardAutopilotOloMigrationErrorParams
* @property {string} errorDescription - err description
* @property {GUID} instance_id - []
* @property {GUID} locationGuid - []
* @property {GUID} bi_token - []
* @property {string} organization_id - guid
* @property {GUID} site_id - guid
**/
/**
 * Name: Dashboard -> Autopilot -> OLO -> Migration Error. Evid: 888.
 * Event description: Autopilot encountered an error while trying to migrate (iframe to ooi).

 * errorDescription - Type: string. Desc: err description
 *
 * instance_id - Type: guid. Desc: []
 *
 * locationGuid - Type: guid. Desc: []
 *
 * bi_token - Type: guid. Desc: []
 *
 * organization_id - Type: string. Desc: guid
 *
 * site_id - Type: guid. Desc: guid
 * @param {dashboardAutopilotOloMigrationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAutopilotOloMigrationError = function (params) {
    return { evid: 888, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} redeemLoyaltyRewardParams
* @property {GUID} locationGuid - null
* @property {number} loyaltyPoints - Loyalty points about to be redeemed
* @property {GUID} oloSessionId - session ID
* @property {string} origin - Origin page, i.e Cart/Checkout
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - null
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Redeem Loyalty Reward. Evid: 865.
 * Event description: OLO-  the UoU clicked on Redeem Loyalty Reward.

 * locationGuid - Type: guid.
 *
 * loyaltyPoints - Type: numeric. Desc: Loyalty points about to be redeemed
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid.
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {redeemLoyaltyRewardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var redeemLoyaltyReward = function (params) {
    return { evid: 865, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorAppSettingsClickParams
* @property {GUID} configurationId - configurationId
* @property {string} currency - currency
* @property {number} discount_subtotal - Total discount
* @property {string} dispatchType - contaclessDineIn/pickup/delivery
* @property {number} estimatedDeliveryTime - Estimated delivery time in minutes(ASAP orders only)
* @property {DateTime} futureOrderTime - Specified future order time
* @property {GUID} integrationAppId - integrationAppId
* @property {string} integrationName - doordash/uber_eats/etc...
* @property {GUID} locationGuid - locationGuid
* @property {number} loyaltyEstimatedEarend - Loyalty points earned(or could have been if not member) from this order
* @property {number} loyaltyPoints - Number of Loyalty points redeemed
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {number} total - Order price total (actual price, without /100)
* @property {number} totalItemsCount - total items count
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout -> Page Load. Evid: 872.
 * Event description: OLO- UoU loaded the Checkout page.

 * configurationId - Type: guid. Desc: configurationId
 *
 * currency - Type: string. Desc: currency
 *
 * discount_subtotal - Type: numeric. Desc: Total discount
 *
 * dispatchType - Type: string. Desc: contaclessDineIn/pickup/delivery
 *
 * estimatedDeliveryTime - Type: numeric. Desc: Estimated delivery time in minutes(ASAP orders only)
 *
 * futureOrderTime - Type: datetime. Desc: Specified future order time
 *
 * integrationAppId - Type: guid. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordash/uber_eats/etc...
 *
 * locationGuid - Type: guid. Desc: locationGuid
 *
 * loyaltyEstimatedEarend - Type: numeric. Desc: Loyalty points earned(or could have been if not member) from this order
 *
 * loyaltyPoints - Type: numeric. Desc: Number of Loyalty points redeemed
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * total - Type: numeric. Desc: Order price total (actual price, without /100)
 *
 * totalItemsCount - Type: numeric. Desc: total items count
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {editorAppSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorAppSettingsClick = function (params) {
    return { evid: 872, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dashboardAutopilotOloMigrationStartParams
* @property {GUID} instance_id - []
* @property {GUID} locationGuid - []
* @property {GUID} bi_token - []
* @property {string} organization_id - guid
* @property {GUID} site_id - guid
* @property {string} statusBeforeMigration - iframe / ooi
**/
/**
 * Name: Dashboard -> Autopilot -> OLO -> Migration Start. Evid: 886.
 * Event description: Autopilot started (iframe to ooi) migration.

 * instance_id - Type: guid. Desc: []
 *
 * locationGuid - Type: guid. Desc: []
 *
 * bi_token - Type: guid. Desc: []
 *
 * organization_id - Type: string. Desc: guid
 *
 * site_id - Type: guid. Desc: guid
 *
 * statusBeforeMigration - Type: string. Desc: iframe / ooi
 * @param {dashboardAutopilotOloMigrationStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAutopilotOloMigrationStart = function (params) {
    return { evid: 886, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartOrderNotesAddedParams
* @property {string} comment - comment
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Order Notes added. Evid: 831.
 * Event description: OLO- In the Cart, the UoU Added Order Notes- AKA the UoU finished adding a comment..

 * comment - Type: string. Desc: comment
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartOrderNotesAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartOrderNotesAdded = function (params) {
    return { evid: 831, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} ooiBannerClickParams
* @property {GUID} locationGuid - null
* @property {string} restaurantId - rest_id
* @property {string} type - banner name
**/
/**
 * Name: OOI -> banner click. Evid: 860.
 * Event description: User clicked on the OOI banner for migration.

 * locationGuid - Type: guid.
 *
 * restaurantId - Type: string. Desc: rest_id
 *
 * type - Type: string. Desc: banner name
 * @param {ooiBannerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ooiBannerClick = function (params) {
    return { evid: 860, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} saveAddressSelectionModalParams
* @property {boolean} isDefault - true/false (Make this my default address)
* @property {boolean} isSuccess - true/false
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} pageName - ‘list’,’edit’,’new’
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Save Address Selection Modal. Evid: 855.
 * Event description: OLO- UoU clicked on the save after clicking on the change on the Delivery Method section in the Checkout (Choose/add delivery address title).

 * isDefault - Type: bool. Desc: true/false (Make this my default address)
 *
 * isSuccess - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * pageName - Type: string. Desc: ‘list’,’edit’,’new’
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {saveAddressSelectionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveAddressSelectionModal = function (params) {
    return { evid: 855, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} paymentsInformationContinueValidationErrorParams
* @property {string} errorReason - Error reason
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} paymentType - manual/paypal/CC
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Payments information continue- validation error. Evid: 817.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Payments information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue).

 * errorReason - Type: string. Desc: Error reason
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * paymentType - Type: string. Desc: manual/paypal/CC
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {paymentsInformationContinueValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var paymentsInformationContinueValidationError = function (params) {
    return { evid: 817, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorSettingsMobileViewParams
* @property {string} button - varies
* @property {string} header - section_navigation / general / display / layout
* @property {GUID} locationGuid - null
* @property {GUID} msid - {guid}
* @property {string} organization_id - {guid}
* @property {string} section - layout / design
* @property {string} sub_section - general / dish
* @property {string} value - active / paused
**/
/**
 * Name: Editor Settings -> Mobile View. Evid: 877.
 * Event description: User event for Editor settings opened through 'Mobile' view..

 * button - Type: string. Desc: varies
 *
 * header - Type: string. Desc: section_navigation / general / display / layout
 *
 * locationGuid - Type: guid.
 *
 * msid - Type: guid. Desc: {guid}
 *
 * organization_id - Type: string. Desc: {guid}
 *
 * section - Type: string. Desc: layout / design
 *
 * sub_section - Type: string. Desc: general / dish
 *
 * value - Type: string. Desc: active / paused
 * @param {editorSettingsMobileViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSettingsMobileView = function (params) {
    return { evid: 877, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorAppSettingsLoadParams
* @property {string} appName - App name
* @property {string} editMode - desktop / mobile
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - oloSessionid
* @property {string} restaurantId - rest id
* @property {string} viewMode - View Mode
**/
/**
 * Name: Editor -> App Settings Load. Evid: 873.
 * Event description: App's settings loaded.

 * appName - Type: string. Desc: App name
 *
 * editMode - Type: string. Desc: desktop / mobile
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: oloSessionid
 *
 * restaurantId - Type: string. Desc: rest id
 *
 * viewMode - Type: string. Desc: View Mode
 * @param {editorAppSettingsLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorAppSettingsLoad = function (params) {
    return { evid: 873, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} openLogOutConfirmationModalParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: open LogOut Confirmation Modal. Evid: 849.
 * Event description: OLO- UoU clicked on the log out banner in the Checkout page.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {openLogOutConfirmationModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openLogOutConfirmationModal = function (params) {
    return { evid: 849, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} navigateToSectionParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} sectionId - Section ID
* @property {string} sectionName - section name
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Navigate to section. Evid: 809.
 * Event description: OLO- UoU clicked on section in the navigation header- (i.e main, desserts, etc.).

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * sectionId - Type: string. Desc: Section ID
 *
 * sectionName - Type: string. Desc: section name
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {navigateToSectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var navigateToSection = function (params) {
    return { evid: 809, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorAppSettingsEditParams
* @property {string} appName - App name
* @property {string} category - display/layout/design/info
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - oloSessionid
* @property {string} restaurantId - rest id
* @property {string} subCategory - [sub category, can contain the whole path of sub categories
* @property {string} value - the value the user chose
* @property {string} viewMode - View Mode
**/
/**
 * Name: Editor -> App settings edit. Evid: 859.
 * Event description: User edited something inside the app settings.

 * appName - Type: string. Desc: App name
 *
 * category - Type: string. Desc: display/layout/design/info
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: oloSessionid
 *
 * restaurantId - Type: string. Desc: rest id
 *
 * subCategory - Type: string. Desc: [sub category, can contain the whole path of sub categories
 *
 * value - Type: string. Desc: the value the user chose
 *
 * viewMode - Type: string. Desc: View Mode
 * @param {editorAppSettingsEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorAppSettingsEdit = function (params) {
    return { evid: 859, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} paymentsInformationContinueParams
* @property {string} currency - currency
* @property {boolean} isCustomTip - true/fasle
* @property {boolean} isDefaultTip - true/false
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} paymentType - CC/Paypal/Offline
* @property {string} restaurantId - organisation ID
* @property {string} tip_type - currency/percentage
* @property {string} tipValue1 - tip value
* @property {number} totalOrderValue - the total amount paid for the order in original currency- including tip, delivery
* @property {number} totalTip - tip
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Payments information continue. Evid: 816.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Payments information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue).

 * currency - Type: string. Desc: currency
 *
 * isCustomTip - Type: bool. Desc: true/fasle
 *
 * isDefaultTip - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * paymentType - Type: string. Desc: CC/Paypal/Offline
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * tip_type - Type: string. Desc: currency/percentage
 *
 * tipValue1 - Type: string. Desc: tip value
 *
 * totalOrderValue - Type: numeric. Desc: the total amount paid for the order in original currency- including tip, delivery
 *
 * totalTip - Type: numeric. Desc: tip
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {paymentsInformationContinueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var paymentsInformationContinue = function (params) {
    return { evid: 816, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dispatchSettingsClickParams
* @property {number} amountTimeSlotDisable - Amount of time slot disabled due to order pacing
* @property {string} clickName - null
* @property {string} clickValue - deivery/pickup/day/time
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} pageName - null
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - null
**/
/**
 * Name: Dispatch settings click. Evid: 883.


 * amountTimeSlotDisable - Type: numeric. Desc: Amount of time slot disabled due to order pacing
 *
 * clickName - Type: string.
 *
 * clickValue - Type: string. Desc: deivery/pickup/day/time
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * pageName - Type: string.
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string.
 * @param {dispatchSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dispatchSettingsClick = function (params) {
    return { evid: 883, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} openAddressSelectionModalParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: open Address Selection Modal. Evid: 854.
 * Event description: OLO- UoU clicked on the change while begin on the Delivery Method section in the Checkout.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {openAddressSelectionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openAddressSelectionModal = function (params) {
    return { evid: 854, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} goToCheckoutParams
* @property {number} abTestSum - always 1
* @property {string} currency - -
* @property {string} feeids - all service fee ids
* @property {number} feesAmount - -
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} restaurantsLocationId - -
* @property {number} taxAmount - -
* @property {number} taxAndFeesAmount - -
* @property {number} totalItemsCount - total items count
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Go to Checkout. Evid: 804.
 * Event description: OLO- UoU clicked on Go to Checkout.

 * abTestSum - Type: numeric. Desc: always 1
 *
 * currency - Type: string. Desc: -
 *
 * feeids - Type: string. Desc: all service fee ids
 *
 * feesAmount - Type: numeric. Desc: -
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * restaurantsLocationId - Type: string. Desc: -
 *
 * taxAmount - Type: numeric. Desc: -
 *
 * taxAndFeesAmount - Type: numeric. Desc: -
 *
 * totalItemsCount - Type: numeric. Desc: total items count
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {goToCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToCheckout = function (params) {
    return { evid: 804, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} navigateToMenuParams
* @property {GUID} locationGuid - null
* @property {string} menuId - menu ID
* @property {string} menuName - menu name
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Navigate to menu. Evid: 808.
 * Event description: OLO- UoU clicked on menu in the navigation header- (i.e dinner menu, lunch menu, etc.).

 * locationGuid - Type: guid.
 *
 * menuId - Type: string. Desc: menu ID
 *
 * menuName - Type: string. Desc: menu name
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {navigateToMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var navigateToMenu = function (params) {
    return { evid: 808, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} fetchOrganizationDataParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID (might be empty in case of retry)
* @property {number} retryNumber - Retry count (zero based)
* @property {number} timestampMs - Timestamp
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Fetch organization data. Evid: 867.
 * Event description: OLO- Editor - fetch organization data on system load.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID (might be empty in case of retry)
 *
 * retryNumber - Type: numeric. Desc: Retry count (zero based)
 *
 * timestampMs - Type: numeric. Desc: Timestamp
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {fetchOrganizationDataParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fetchOrganizationData = function (params) {
    return { evid: 867, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editAddressSelectionModalParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Edit Address Selection Modal. Evid: 856.
 * Event description: OLO- UoU clicked on the edit  while Choosing delivery address (Wants to edit one of the addresses).

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {editAddressSelectionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editAddressSelectionModal = function (params) {
    return { evid: 856, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartDishQuantitiesUpdateParams
* @property {string} action - increase (+)/decrease (-)
* @property {string} dishId - dish ID
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {number} quantity - item count (after the update)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> dish quantities update. Evid: 821.
 * Event description: OLO- In the Cart, the UoU clicked on +/- to add/remove the dish' quantity..

 * action - Type: string. Desc: increase (+)/decrease (-)
 *
 * dishId - Type: string. Desc: dish ID
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * quantity - Type: numeric. Desc: item count (after the update)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartDishQuantitiesUpdateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartDishQuantitiesUpdate = function (params) {
    return { evid: 821, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dispatchChangeClickParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} pageName - menus / checkout
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Dispatch change click. Evid: 875.
 * Event description: OLO- UoU clicked on to change the dispatch.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * pageName - Type: string. Desc: menus / checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {dispatchChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dispatchChangeClick = function (params) {
    return { evid: 875, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} locationPickedParams
* @property {string} dispatchType - delivery/pickup
* @property {GUID} locationGuid - location ID
* @property {string} pageName - menus / checkout
* @property {string} validationError - choosing a new location will empty your cart
* @property {string} viewMode - preview/live site
**/
/**
 * Name: Location Picked. Evid: 846.
 * Event description: UoU picks a location in dispatch settings.

 * dispatchType - Type: string. Desc: delivery/pickup
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * pageName - Type: string. Desc: menus / checkout
 *
 * validationError - Type: string. Desc: choosing a new location will empty your cart
 *
 * viewMode - Type: string. Desc: preview/live site
 * @param {locationPickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var locationPicked = function (params) {
    return { evid: 846, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} previewOnboardingModalLoadParams
* @property {GUID} instance_id - {}
* @property {GUID} locationGuid - null
* @property {GUID} bi_token - {}
* @property {GUID} oloSessionId - olo_session_id
* @property {string} restaurantId - rest_id
* @property {string} type - Payments/Premium
* @property {string} viewMode - preview/live site
**/
/**
 * Name: Preview -> Onboarding Modal load. Evid: 845.
 * Event description: After trying to continue to Checkout without Premium, or Payments a modal will be shown to the user in order to connect (Premium, or Payments).

 * instance_id - Type: guid. Desc: {}
 *
 * locationGuid - Type: guid.
 *
 * bi_token - Type: guid. Desc: {}
 *
 * oloSessionId - Type: guid. Desc: olo_session_id
 *
 * restaurantId - Type: string. Desc: rest_id
 *
 * type - Type: string. Desc: Payments/Premium
 *
 * viewMode - Type: string. Desc: preview/live site
 * @param {previewOnboardingModalLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewOnboardingModalLoad = function (params) {
    return { evid: 845, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} submitOrderFailureParams
* @property {number} errorCode - error code
* @property {string} errorCodeString - new field for error code (replacing the old one- errorCode) since POS error is sending as a string
* @property {number} fee_count - -
* @property {boolean} isDeliveryPartner - provided by a delivery partner
* @property {boolean} isPos - true if order was created with POS
* @property {GUID} locationGuid - null
* @property {GUID} oloRequestId - In order to track submit order, success order, failure
* @property {GUID} oloSessionId - session ID
* @property {string} posProviderId - true if the order is with POS
* @property {string} rejectReason - failure reason
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Submit Order - failure. Evid: 807.
 * Event description: OLO- order submitted and failed, payment method --not-- charged..

 * errorCode - Type: numeric. Desc: error code
 *
 * errorCodeString - Type: string. Desc: new field for error code (replacing the old one- errorCode) since POS error is sending as a string
 *
 * fee_count - Type: numeric. Desc: -
 *
 * isDeliveryPartner - Type: bool. Desc: provided by a delivery partner
 *
 * isPos - Type: bool. Desc: true if order was created with POS
 *
 * locationGuid - Type: guid.
 *
 * oloRequestId - Type: guid. Desc: In order to track submit order, success order, failure
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * posProviderId - Type: string. Desc: true if the order is with POS
 *
 * rejectReason - Type: string. Desc: failure reason
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {submitOrderFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var submitOrderFailure = function (params) {
    return { evid: 807, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutEditParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} type - Delivery/Contact/Payments
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout -> edit. Evid: 834.
 * Event description: OLO- During the checkout, the UoU clicked on the "edit" button in one of the Checkout Stages- AKA Delivery Method/Contact Information/Payments.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * type - Type: string. Desc: Delivery/Contact/Payments
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {checkoutEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutEdit = function (params) {
    return { evid: 834, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} pickupShowOnMapClickParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} pageName - dispatch settings / checkout
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: pickup --> show on map click. Evid: 874.
 * Event description: OLO- UoU clicked on the "Show on map"  in the pickup dispatch settings.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * pageName - Type: string. Desc: dispatch settings / checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {pickupShowOnMapClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pickupShowOnMapClick = function (params) {
    return { evid: 874, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addToCartFailureParams
* @property {string} lastState - delivery/pickup/dine-in
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Dispatch update. Evid: 830.
 * Event description: UoU changed dispatch option in the checkout, while in the address information.

 * lastState - Type: string. Desc: delivery/pickup/dine-in
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {addToCartFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addToCartFailure = function (params) {
    return { evid: 830, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorOoiMigrationPublishModalClickParams
* @property {string} actionName - 'got_it'
* @property {GUID} locationGuid - []
* @property {string} organizationId - rest_id
**/
/**
 * Name: Editor -> OOI Migration -> Publish Modal -> Click. Evid: 881.
 * Event description: user clicked on the modal, after it asked him to publish site..

 * actionName - Type: string. Desc: 'got_it'
 *
 * locationGuid - Type: guid. Desc: []
 *
 * organizationId - Type: string. Desc: rest_id
 * @param {editorOoiMigrationPublishModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorOoiMigrationPublishModalClick = function (params) {
    return { evid: 881, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} liveSiteDeliveryPartnerEstimationNotSentNoOnlinePaymentsParams
* @property {GUID} configurationId - configurationId
* @property {GUID} integrationAppId - integrationAppId
* @property {string} integrationName - doordash/uber_eats/etc...
* @property {GUID} locationGuid - locationGuid
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} stage - null
* @property {string} viewMode - null
**/
/**
 * Name: Live Site -> Delivery Partner Estimation Not Sent -> No Online Payments. Evid: 880.
 * Event description: If the User does not have online payments, then the estimation will not be sent to the delivery partner, causing an error.

 * configurationId - Type: guid. Desc: configurationId
 *
 * integrationAppId - Type: guid. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordash/uber_eats/etc...
 *
 * locationGuid - Type: guid. Desc: locationGuid
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * stage - Type: string.
 *
 * viewMode - Type: string.
 * @param {liveSiteDeliveryPartnerEstimationNotSentNoOnlinePaymentsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var liveSiteDeliveryPartnerEstimationNotSentNoOnlinePayments = function (params) {
    return { evid: 880, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} loyaltyEditPointsSaveParams
* @property {GUID} locationGuid - locationGuid
* @property {number} loyaltyPoints - Loyalty points about to be redeemed after change
* @property {GUID} oloSessionId - .
* @property {string} origin - Origin page, i.e Cart/Checkout
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - Reward ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Loyalty Edit Points Save. Evid: 869.
 * Event description: OLO- the UoU clicked on "save" under the Loyalty Reward after clicking on edit.

 * locationGuid - Type: guid. Desc: locationGuid
 *
 * loyaltyPoints - Type: numeric. Desc: Loyalty points about to be redeemed after change
 *
 * oloSessionId - Type: guid. Desc: .
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: Reward ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {loyaltyEditPointsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loyaltyEditPointsSave = function (params) {
    return { evid: 869, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} siteMigratedToOoiParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: site migrated to OOI. Evid: 858.
 * Event description: OLO- user migrated to OOI.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {siteMigratedToOoiParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteMigratedToOoi = function (params) {
    return { evid: 858, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorOpenBoClickParams
* @property {string} appName - App name
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - oloSessionid
* @property {string} restaurantId - rest id
* @property {string} type - toggledOn/ toggledOff
* @property {string} viewMode - View Mode
**/
/**
 * Name: Editor -> Open BO Click. Evid: 868.
 * Event description: user clicked on one of the manage button linking to the app's BO.

 * appName - Type: string. Desc: App name
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: oloSessionid
 *
 * restaurantId - Type: string. Desc: rest id
 *
 * type - Type: string. Desc: toggledOn/ toggledOff
 *
 * viewMode - Type: string. Desc: View Mode
 * @param {editorOpenBoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorOpenBoClick = function (params) {
    return { evid: 868, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} smsValidationSuccessParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: SMS validation- Success. Evid: 836.
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
added the code with success.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {smsValidationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smsValidationSuccess = function (params) {
    return { evid: 836, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorUpgradeToPremiumParams
* @property {string} appName - olo/menus/reservations
* @property {GUID} instance_id - {}
* @property {GUID} locationGuid - null
* @property {GUID} bi_token - {}
* @property {GUID} oloSessionId - olo_session_id
* @property {string} origin - footer/tab/modal
* @property {string} restaurantId - rest_id
* @property {string} viewMode - preview/live site
**/
/**
 * Name: Editor ->upgrade to premium. Evid: 842.
 * Event description: 3 New entry points to premium upgrade in the Editor (app settings, modals):
Footer, modal (after trying to continue to Checkout without Premium ) and tab..

 * appName - Type: string. Desc: olo/menus/reservations
 *
 * instance_id - Type: guid. Desc: {}
 *
 * locationGuid - Type: guid.
 *
 * bi_token - Type: guid. Desc: {}
 *
 * oloSessionId - Type: guid. Desc: olo_session_id
 *
 * origin - Type: string. Desc: footer/tab/modal
 *
 * restaurantId - Type: string. Desc: rest_id
 *
 * viewMode - Type: string. Desc: preview/live site
 * @param {editorUpgradeToPremiumParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorUpgradeToPremium = function (params) {
    return { evid: 842, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dispatchSettingsUpdateParams
* @property {GUID} configurationId - configurationId
* @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
* @property {string} contactlessDineInUOUInput - UoU input / null
* @property {string} curbsideAdditionalInformationContent - string/null
* @property {boolean} curbsidePickupToggle - true/false
* @property {DateTime} dispatchTime - delivery/pickup hour (In UTC+0 time)
* @property {string} dispatchTimeOption - asap/later
* @property {string} dispatchType - delivery/pickup/dine-in
* @property {number} estimatedDeliveryTime - Estimated delivery time in minutes(ASAP orders only)
* @property {GUID} integrationAppId - integrationAppId
* @property {string} integrationName - doordasg/uber_eats/etc...
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} validationError - Outfit Description / location-changed
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: dispatch settings update. Evid: 811.
 * Event description: OLO- UoU clicked on the "SAVE" button in the dispatch settings -AKA dispatch settings updated.

 * configurationId - Type: guid. Desc: configurationId
 *
 * contactlessDineInInputLabel - Type: string. Desc: User's input label as defined at the settings / null
 *
 * contactlessDineInUOUInput - Type: string. Desc: UoU input / null
 *
 * curbsideAdditionalInformationContent - Type: string. Desc: string/null
 *
 * curbsidePickupToggle - Type: bool. Desc: true/false
 *
 * dispatchTime - Type: datetime. Desc: delivery/pickup hour (In UTC+0 time)
 *
 * dispatchTimeOption - Type: string. Desc: asap/later
 *
 * dispatchType - Type: string. Desc: delivery/pickup/dine-in
 *
 * estimatedDeliveryTime - Type: numeric. Desc: Estimated delivery time in minutes(ASAP orders only)
 *
 * integrationAppId - Type: guid. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordasg/uber_eats/etc...
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * validationError - Type: string. Desc: Outfit Description / location-changed
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {dispatchSettingsUpdateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dispatchSettingsUpdate = function (params) {
    return { evid: 811, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} loyaltyEditPointsChangeValueParams
* @property {GUID} locationGuid - locationGuid
* @property {number} loyaltyPoints - Loyalty points about to be redeemed after change
* @property {GUID} oloSessionId - .
* @property {string} origin - Origin page, i.e Cart/Checkout
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - Reward ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Loyalty Edit Points Change Value. Evid: 870.
 * Event description: OLO- the UoU clicked on a value in the dropdown list, under the Loyalty Reward, after clicking on edit.

 * locationGuid - Type: guid. Desc: locationGuid
 *
 * loyaltyPoints - Type: numeric. Desc: Loyalty points about to be redeemed after change
 *
 * oloSessionId - Type: guid. Desc: .
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: Reward ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {loyaltyEditPointsChangeValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loyaltyEditPointsChangeValue = function (params) {
    return { evid: 870, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} submitOrderSuccessParams
* @property {boolean} isDeliveryPartner - provided by a delivery partner
* @property {boolean} isPos - true if order was created with POS
* @property {GUID} locationGuid - null
* @property {GUID} oloRequestId - In order to track submit order, success order, failure
* @property {GUID} oloSessionId - session ID
* @property {string} orderId - Order ID
* @property {string} posProviderId - true if the order is with POS
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Submit Order - success. Evid: 806.
 * Event description: OLO- order submitted successfully, payment method charged..

 * isDeliveryPartner - Type: bool. Desc: provided by a delivery partner
 *
 * isPos - Type: bool. Desc: true if order was created with POS
 *
 * locationGuid - Type: guid.
 *
 * oloRequestId - Type: guid. Desc: In order to track submit order, success order, failure
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * orderId - Type: string. Desc: Order ID
 *
 * posProviderId - Type: string. Desc: true if the order is with POS
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {submitOrderSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var submitOrderSuccess = function (params) {
    return { evid: 806, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dashboardAutopilotOloLogMigrationParams
* @property {GUID} instance_id - []
* @property {GUID} locationGuid - null
* @property {string} log - free text
* @property {GUID} bi_token - []
* @property {string} organization_id - guid
* @property {GUID} site_id - guid
**/
/**
 * Name: Dashboard -> Autopilot -> OLO -> Log Migration. Evid: 889.
 * Event description: Autopilots logs in the migration.

 * instance_id - Type: guid. Desc: []
 *
 * locationGuid - Type: guid.
 *
 * log - Type: string. Desc: free text
 *
 * bi_token - Type: guid. Desc: []
 *
 * organization_id - Type: string. Desc: guid
 *
 * site_id - Type: guid. Desc: guid
 * @param {dashboardAutopilotOloLogMigrationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAutopilotOloLogMigration = function (params) {
    return { evid: 889, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} submitOrderParams
* @property {number} abTestSum - always 1
* @property {boolean} changeTimedueToDelay - true if the user changed the time due to a delay alert
* @property {GUID} configurationId - configurationId
* @property {GUID} contactId - null
* @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
* @property {string} contactlessDineInUOUInput - UoU's input / null
* @property {string} currency - currency
* @property {boolean} delayAlertShown - .true  if delay alert shown (order pacing)
* @property {number} deliveryFee - deliveryFee in local currency
* @property {number} discount_subtotal - Total discount
* @property {string} dispatchType - contaclessDineIn/pickup/delivery
* @property {number} estimatedDeliveryTime - Estimated delivery time in minutes(ASAP orders only)
* @property {string} feeIds - all service fees ids
* @property {string} fee_type - (percentage, amount)
* @property {number} feesAmount - -
* @property {number} feesCount - -
* @property {GUID} integrationAppId - integrationAppId
* @property {string} integrationName - doordash/uber_eats/etc...
* @property {boolean} isConsentCheckboxChecked - Wether the order done with check box or not
* @property {boolean} isConsentRequired - order submited with/without some type of consent (Terms/policy/etc)
* @property {boolean} isContactless - true/false
* @property {boolean} isDeliveryPartner - States if the order was fulfilled by a delivery partner
* @property {boolean} isMember - order done by a member
* @property {boolean} isPos - true if the order is with POS
* @property {GUID} locationGuid - null
* @property {number} loyaltyEstimatedEarend - Loyalty points earned(or could have been if not member) from this order
* @property {number} loyaltyPoints - Number of Loyalty points redeemed
* @property {number} loyaltyPrice - Actual local currency value of the points redeemed
* @property {GUID} oloRequestId - In order to track submit order, success order, failure
* @property {GUID} oloSessionId - session ID
* @property {string} posProviderId - if the restaurants location connected to POS then send provider id, if not null
* @property {string} restaurantId - organisation ID
* @property {string} restaurantsLocationId - -
* @property {GUID} rewardId - RewardID
* @property {number} taxAmount - -
* @property {number} taxAndFeesAmount - -
* @property {number} tipSubtotal - total tip
* @property {string} tipType - % or $
* @property {string} tipValue1 - null
* @property {number} total - Order price total (actual price, without /100)
* @property {number} totalItemsCount - total items count
* @property {number} totalLoyaltyPoints - The total points after the order was submitted(estimated)
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Submit Order. Evid: 805.
 * Event description: OLO- UoU clicked on Submit Order.

 * abTestSum - Type: numeric. Desc: always 1
 *
 * changeTimedueToDelay - Type: bool. Desc: true if the user changed the time due to a delay alert
 *
 * configurationId - Type: guid. Desc: configurationId
 *
 * contactId - Type: guid.
 *
 * contactlessDineInInputLabel - Type: string. Desc: User's input label as defined at the settings / null
 *
 * contactlessDineInUOUInput - Type: string. Desc: UoU's input / null
 *
 * currency - Type: string. Desc: currency
 *
 * delayAlertShown - Type: bool. Desc: .true  if delay alert shown (order pacing)
 *
 * deliveryFee - Type: numeric. Desc: deliveryFee in local currency
 *
 * discount_subtotal - Type: numeric. Desc: Total discount
 *
 * dispatchType - Type: string. Desc: contaclessDineIn/pickup/delivery
 *
 * estimatedDeliveryTime - Type: numeric. Desc: Estimated delivery time in minutes(ASAP orders only)
 *
 * feeIds - Type: string. Desc: all service fees ids
 *
 * fee_type - Type: string. Desc: (percentage, amount)
 *
 * feesAmount - Type: numeric. Desc: -
 *
 * feesCount - Type: numeric. Desc: -
 *
 * integrationAppId - Type: guid. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordash/uber_eats/etc...
 *
 * isConsentCheckboxChecked - Type: bool. Desc: Wether the order done with check box or not
 *
 * isConsentRequired - Type: bool. Desc: order submited with/without some type of consent (Terms/policy/etc)
 *
 * isContactless - Type: bool. Desc: true/false
 *
 * isDeliveryPartner - Type: bool. Desc: States if the order was fulfilled by a delivery partner
 *
 * isMember - Type: bool. Desc: order done by a member
 *
 * isPos - Type: bool. Desc: true if the order is with POS
 *
 * locationGuid - Type: guid.
 *
 * loyaltyEstimatedEarend - Type: numeric. Desc: Loyalty points earned(or could have been if not member) from this order
 *
 * loyaltyPoints - Type: numeric. Desc: Number of Loyalty points redeemed
 *
 * loyaltyPrice - Type: numeric. Desc: Actual local currency value of the points redeemed
 *
 * oloRequestId - Type: guid. Desc: In order to track submit order, success order, failure
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * posProviderId - Type: string. Desc: if the restaurants location connected to POS then send provider id, if not null
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * restaurantsLocationId - Type: string. Desc: -
 *
 * rewardId - Type: guid. Desc: RewardID
 *
 * taxAmount - Type: numeric. Desc: -
 *
 * taxAndFeesAmount - Type: numeric. Desc: -
 *
 * tipSubtotal - Type: numeric. Desc: total tip
 *
 * tipType - Type: string. Desc: % or $
 *
 * tipValue1 - Type: string.
 *
 * total - Type: numeric. Desc: Order price total (actual price, without /100)
 *
 * totalItemsCount - Type: numeric. Desc: total items count
 *
 * totalLoyaltyPoints - Type: numeric. Desc: The total points after the order was submitted(estimated)
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {submitOrderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var submitOrder = function (params) {
    return { evid: 805, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addToCartValidationErrorParams
* @property {string} dishId - dish ID
* @property {string} errorReason - variation error
* @property {number} errorsCount - number of errors (In the variations)
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Add to cart- validation error. Evid: 819.
 * Event description: OLO- UoU clicked on the button - "Add to my Order" in the Dish Modal-  (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue).

 * dishId - Type: string. Desc: dish ID
 *
 * errorReason - Type: string. Desc: variation error
 *
 * errorsCount - Type: numeric. Desc: number of errors (In the variations)
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {addToCartValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addToCartValidationError = function (params) {
    return { evid: 819, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} logOutConfirmationModalCancelClickParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: log out confirmation modal -> cancel click. Evid: 851.
 * Event description: OLO- UoU clicked on the log out click, on the log out modal on the Return to Checkout.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {logOutConfirmationModalCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logOutConfirmationModalCancelClick = function (params) {
    return { evid: 851, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} oloAutoCompleteEventsForMonitorBugsParams
* @property {string} address - -
* @property {string} city - -
* @property {string} country - -
* @property {string} formattedAddress - -
* @property {string} geocode - null
* @property {GUID} locationGuid - null
* @property {string} placeId - -
* @property {string} postalCode - -
* @property {string} streetAddress - -
* @property {string} subdivisions - -
**/
/**
 * Name: OLO - auto complete - events for monitor bugs. Evid: 890.
 * Event description: when the data of the chosen location from auto-complete  is returned.

 * address - Type: string. Desc: -
 *
 * city - Type: string. Desc: -
 *
 * country - Type: string. Desc: -
 *
 * formattedAddress - Type: string. Desc: -
 *
 * geocode - Type: string.
 *
 * locationGuid - Type: guid.
 *
 * placeId - Type: string. Desc: -
 *
 * postalCode - Type: string. Desc: -
 *
 * streetAddress - Type: string. Desc: -
 *
 * subdivisions - Type: string. Desc: -
 * @param {oloAutoCompleteEventsForMonitorBugsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oloAutoCompleteEventsForMonitorBugs = function (params) {
    return { evid: 890, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} restaurantsNetworkPerfParams
* @property {boolean} isSsr - .
* @property {GUID} locationGuid - null
* @property {string} methodType - nodejs, v2.1, v2.1-location-first
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {number} totalTime - ms
**/
/**
 * Name: restaurants Network Perf. Evid: 878.
 * Event description: Check performance.

 * isSsr - Type: bool. Desc: .
 *
 * locationGuid - Type: guid.
 *
 * methodType - Type: string. Desc: nodejs, v2.1, v2.1-location-first
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * totalTime - Type: numeric. Desc: ms
 * @param {restaurantsNetworkPerfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsNetworkPerf = function (params) {
    return { evid: 878, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} logInRequestParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} origin - Origin page, i.e Cart/Checkout/ThankYouPage
* @property {GUID} requestid - request Id to join with log in success
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: log in Request. Evid: 847.
 * Event description: OLO- UoU clicked on the log in banner in the Checkout page.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout/ThankYouPage
 *
 * requestid - Type: guid. Desc: request Id to join with log in success
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {logInRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logInRequest = function (params) {
    return { evid: 847, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} futureOrdersErrorParams
* @property {string} details - details
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Future Orders-> Error. Evid: 838.
 * Event description: UoU future Orders Error- hedge case let's say it is now 4pm, and I want to place a future order for 4:30pm and the prep time for pickup is 30 min. I start filling out my cart at 4pm and then I went to the kitchen to wash dishes, and came back at 4:15pm to place my order. I will be able to proceed until final checkout step - and then get a "something went wrong error"..

 * details - Type: string. Desc: details
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {futureOrdersErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var futureOrdersError = function (params) {
    return { evid: 838, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartRemoveDishParams
* @property {string} dishId - dish ID
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Remove Dish. Evid: 822.
 * Event description: OLO- In the Cart, the UoU clicked on "remove" under the dish name.

 * dishId - Type: string. Desc: dish ID
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartRemoveDishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartRemoveDish = function (params) {
    return { evid: 822, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} liveSiteDeliveryPartnerEstimationsParams
* @property {GUID} configurationId - configurationId
* @property {string} currency - currency
* @property {number} deliveryFee - The delivery fee in the local currency
* @property {string} errorDescription - errorDescription
* @property {GUID} estimateId - estimateId
* @property {string} integrationAppId - integrationAppId
* @property {string} integrationName - doordash/uber_eats/etc...
* @property {GUID} locationGuid - locationGuid
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} stage - dispatch settings/delivery method/submit order
* @property {boolean} status - true = success, false = error
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Live Site -> Delivery Partner Estimations. Evid: 879.
 * Event description: An estimation for the availability and delivery fee from a delivery partner.
Can be sent in three different points:
dispatch settings
delivery method (after continue click)
submit order.

 * configurationId - Type: guid. Desc: configurationId
 *
 * currency - Type: string. Desc: currency
 *
 * deliveryFee - Type: numeric. Desc: The delivery fee in the local currency
 *
 * errorDescription - Type: string. Desc: errorDescription
 *
 * estimateId - Type: guid. Desc: estimateId
 *
 * integrationAppId - Type: string. Desc: integrationAppId
 *
 * integrationName - Type: string. Desc: doordash/uber_eats/etc...
 *
 * locationGuid - Type: guid. Desc: locationGuid
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * stage - Type: string. Desc: dispatch settings/delivery method/submit order
 *
 * status - Type: bool. Desc: true = success, false = error
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {liveSiteDeliveryPartnerEstimationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var liveSiteDeliveryPartnerEstimations = function (params) {
    return { evid: 879, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} boltExceptionParams
* @property {GUID} locationGuid - null
**/
/**
 * Name: Bolt exception. Evid: 871.
 * Event description: Bolt exception.

 * locationGuid - Type: guid.
 * @param {boltExceptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boltException = function (params) {
    return { evid: 871, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} smsValidationFailureParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: SMS validation- Failure. Evid: 837.
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
added the code without success- Failure.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {smsValidationFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smsValidationFailure = function (params) {
    return { evid: 837, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartAddPromoCodeParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Add promo code. Evid: 825.
 * Event description: OLO- In the Cart, the UoU clicked on "Add promo code "- AKA the UoU will add the promo code (Not yet added).

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartAddPromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartAddPromoCode = function (params) {
    return { evid: 825, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartDiscardParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Discard. Evid: 823.
 * Event description: OLO- In the Cart, the UoU closed the cart- without continuing the Checkout.
clicked on X/Click Outside/esc.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartDiscardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartDiscard = function (params) {
    return { evid: 823, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} loyaltyViewMyRewardsParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - Reward ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Loyalty -> View My Rewards. Evid: 863.
 * Event description: OLO- the UoU clicked on "view my rewards" at the members view of the Thank You page.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: Reward ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {loyaltyViewMyRewardsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loyaltyViewMyRewards = function (params) {
    return { evid: 863, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addNewAddressSelectionModalParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Add new Address Selection Modal. Evid: 857.
 * Event description: OLO- UoU clicked on the Add New Address while Choosing delivery address (Wants to add a new address).

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {addNewAddressSelectionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addNewAddressSelectionModal = function (params) {
    return { evid: 857, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} initSessionParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} uouTestId - optional field- if UOU test  is running then test ID, if not null
* @property {string} uouTestLabel - optional field- if UOU test  is running then UOU label (a/b/c), if not null
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: init session. Evid: 800.
 * Event description: OLO- UoU started session- Page load.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * uouTestId - Type: string. Desc: optional field- if UOU test  is running then test ID, if not null
 *
 * uouTestLabel - Type: string. Desc: optional field- if UOU test  is running then UOU label (a/b/c), if not null
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {initSessionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var initSession = function (params) {
    return { evid: 800, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartPromoCodeApplyFailureParams
* @property {string} errorReason - The error as it's presented to the UoU
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} promoCode - promo code added with success
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> promo code Apply- Failure. Evid: 827.
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with Failure.

 * errorReason - Type: string. Desc: The error as it's presented to the UoU
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * promoCode - Type: string. Desc: promo code added with success
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartPromoCodeApplyFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartPromoCodeApplyFailure = function (params) {
    return { evid: 827, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartDiscountDetailsParams
* @property {string} action - show/hide
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} type - discount/promo code
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> Discount details. Evid: 824.
 * Event description: OLO- In the Cart, the UoU clicked on "show/hide details" under the discounts (Promo code/discounts)..

 * action - Type: string. Desc: show/hide
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * type - Type: string. Desc: discount/promo code
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartDiscountDetailsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartDiscountDetails = function (params) {
    return { evid: 824, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutBackToMenuParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: checkout -> back to menu. Evid: 820.
 * Event description: OLO- During the checkout, the UoU clicked on "Back to Menu" button in order to continue the order.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {checkoutBackToMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutBackToMenu = function (params) {
    return { evid: 820, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartPromoCodeApplySuccessParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} promoCode - promo code added with success
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> promo code Apply success. Evid: 826.
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with success.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * promoCode - Type: string. Desc: promo code added with success
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartPromoCodeApplySuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartPromoCodeApplySuccess = function (params) {
    return { evid: 826, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkboxSaveAddressForFutureOrdersParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} value - on/off
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Checkbox save address for future orders. Evid: 852.
 * Event description: OLO- UoU clicked on the checkbox during the checkout (In the delivery method section).

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * value - Type: string. Desc: on/off
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {checkboxSaveAddressForFutureOrdersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkboxSaveAddressForFutureOrders = function (params) {
    return { evid: 852, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} removeLoyaltyRewardParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} origin - Origin page, i.e Cart/Checkout
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - Reward ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Remove Loyalty Reward. Evid: 862.
 * Event description: OLO- the UoU clicked on "remove" under the Loyalty Reward.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: Reward ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {removeLoyaltyRewardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeLoyaltyReward = function (params) {
    return { evid: 862, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} cartPromoCodeRemoveParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} promoCode - Promo Code that was removed
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Cart -> PromoCode -> Remove. Evid: 828.
 * Event description: OLO- In the Cart, the UoU clicked on "remove" after adding a promo code.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * promoCode - Type: string. Desc: Promo Code that was removed
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {cartPromoCodeRemoveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartPromoCodeRemove = function (params) {
    return { evid: 828, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} loyaltyEditPointsParams
* @property {GUID} locationGuid - null
* @property {number} loyaltyPoints - Loyalty points about to be redeemed
* @property {number} numOfOptions - Number of options in the dropdown list
* @property {GUID} oloSessionId - session ID
* @property {string} origin - Origin page, i.e Cart/Checkout
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - Reward ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Loyalty Edit Points. Evid: 864.
 * Event description: OLO- the UoU clicked on "edit" under the Loyalty Reward and opened a drop down list containing the point options.

 * locationGuid - Type: guid.
 *
 * loyaltyPoints - Type: numeric. Desc: Loyalty points about to be redeemed
 *
 * numOfOptions - Type: numeric. Desc: Number of options in the dropdown list
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: Reward ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {loyaltyEditPointsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loyaltyEditPoints = function (params) {
    return { evid: 864, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} contactInformationContinueParams
* @property {string} emailDomain - @wix.com/@gmail.com
* @property {boolean} isOverridden - wether the member overrided the contact info
* @property {boolean} isSaved - wether the continue clicked by a saved member
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Contact information continue. Evid: 814.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Contact information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue).

 * emailDomain - Type: string. Desc: @wix.com/@gmail.com
 *
 * isOverridden - Type: bool. Desc: wether the member overrided the contact info
 *
 * isSaved - Type: bool. Desc: wether the continue clicked by a saved member
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {contactInformationContinueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactInformationContinue = function (params) {
    return { evid: 814, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorConnectPaymentCtaParams
* @property {GUID} instance_id - {}
* @property {GUID} locationGuid - null
* @property {GUID} bi_token - {}
* @property {GUID} oloSessionId - olo_session_id
* @property {string} restaurantId - rest_id
* @property {string} viewMode - preview/live site
**/
/**
 * Name: Editor -> Connect Payment CTA. Evid: 843.
 * Event description: New entry point to connect payment in the Editor Preview.
It will be trigger when trying to continue to Checkout, premium is connected, but no payments..

 * instance_id - Type: guid. Desc: {}
 *
 * locationGuid - Type: guid.
 *
 * bi_token - Type: guid. Desc: {}
 *
 * oloSessionId - Type: guid. Desc: olo_session_id
 *
 * restaurantId - Type: string. Desc: rest_id
 *
 * viewMode - Type: string. Desc: preview/live site
 * @param {editorConnectPaymentCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorConnectPaymentCta = function (params) {
    return { evid: 843, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} liveSiteMinimumOrderErrorParams
* @property {string} dispatchType - delivery/pickup
* @property {GUID} locationGuid - .
* @property {number} minimumOrder - minimum defined for pickup/delivery *100
* @property {GUID} oloSessionId - session ID
* @property {string} pageName - view cart/ Checkout
* @property {number} price - current order price
* @property {string} restaurantId - organisation ID
**/
/**
 * Name: Live site-> Minimum order error. Evid: 861.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from address information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue).

 * dispatchType - Type: string. Desc: delivery/pickup
 *
 * locationGuid - Type: guid. Desc: .
 *
 * minimumOrder - Type: numeric. Desc: minimum defined for pickup/delivery *100
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * pageName - Type: string. Desc: view cart/ Checkout
 *
 * price - Type: numeric. Desc: current order price
 *
 * restaurantId - Type: string. Desc: organisation ID
 * @param {liveSiteMinimumOrderErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var liveSiteMinimumOrderError = function (params) {
    return { evid: 861, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} logOutConfirmationModalCtaClickParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: log out confirmation modal -> CTA click. Evid: 850.
 * Event description: OLO- UoU clicked on the log out click, on the log out modal (Actually wants to log out).

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {logOutConfirmationModalCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logOutConfirmationModalCtaClick = function (params) {
    return { evid: 850, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} contactlessDineInLocationUnavailableModalLoadParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Contactless Dine-in -> Location Unavailable Modal Load. Evid: 884.
 * Event description: Location was unavailable (location was toggled off) and the UoU loaded the modal in the live site.

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {contactlessDineInLocationUnavailableModalLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactlessDineInLocationUnavailableModalLoad = function (params) {
    return { evid: 884, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dishModalDiscardParams
* @property {string} dishId - dish ID
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} origin - menu/cart
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Dish modal - discard. Evid: 818.
 * Event description: OLO- UoU closed the dish modal without adding the dish to the cart ( either click on X/click outside/cancel/esc).

 * dishId - Type: string. Desc: dish ID
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: menu/cart
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {dishModalDiscardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dishModalDiscard = function (params) {
    return { evid: 818, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} openDispatchSettingsParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} openReason - click on dish / click on dispatch
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Open dispatch settings. Evid: 810.
 * Event description: OLO- UoU clicked on the dispatch settings - i.e delivery instead of pick-up, etc..

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * openReason - Type: string. Desc: click on dish / click on dispatch
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {openDispatchSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openDispatchSettings = function (params) {
    return { evid: 810, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutNoPaymentMethodParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: checkout -> No payment method. Evid: 840.
 * Event description: OLO-The UoU arrived to the checkout, no payment method loaded (No existing payment method).

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {checkoutNoPaymentMethodParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutNoPaymentMethod = function (params) {
    return { evid: 840, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addToCartParams
* @property {string} dishId - dish ID
* @property {GUID} fee_id - fee_id
* @property {string} fee_type - (percentage, amount)
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {number} quantity - item count
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Add to cart. Evid: 802.
 * Event description: OLO- UoU added dish to cart.

 * dishId - Type: string. Desc: dish ID
 *
 * fee_id - Type: guid. Desc: fee_id
 *
 * fee_type - Type: string. Desc: (percentage, amount)
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * quantity - Type: numeric. Desc: item count
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {addToCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addToCart = function (params) {
    return { evid: 802, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} closeDispatchSettingsParams
* @property {string} close_type - cancel/exit/esc
* @property {GUID} locationGuid - location guid
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: close dispatch settings. Evid: 876.
 * Event description: OLO- UoU clicked on cancel/exit dispatch settings or esc (clicked outside the dispatch setting box).

 * close_type - Type: string. Desc: cancel/exit/esc
 *
 * locationGuid - Type: guid. Desc: location guid
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {closeDispatchSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeDispatchSettings = function (params) {
    return { evid: 876, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} smsValidationDisplayParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: SMS validation display. Evid: 835.
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded).

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {smsValidationDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smsValidationDisplay = function (params) {
    return { evid: 835, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} contactlessDineInLocationUnavailableModalClickParams
* @property {string} buttonType - x/back_to_online_ordering
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Contactless Dine-in -> Location Unavailable Modal Click. Evid: 885.
 * Event description: Location was unavailable (location was toggled off) and the UoU loaded the modal in the live site.

 * buttonType - Type: string. Desc: x/back_to_online_ordering
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {contactlessDineInLocationUnavailableModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactlessDineInLocationUnavailableModalClick = function (params) {
    return { evid: 885, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} addressInformationContinueParams
* @property {string} comment - comment
* @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
* @property {string} contactlessDineInUOUInput - UoU's input / null
* @property {string} curbsideAdditionalInformationContent - string/null
* @property {boolean} curbsidePickupToggle - true/false
* @property {boolean} delayAlertShown - true if delay alert is shown (order pacing)
* @property {DateTime} dispatchTime - delivery/pickup hour
* @property {string} dispatchTimeOption - asap/later
* @property {string} dispatchType - delivery/pickup/dine-in
* @property {DateTime} futureOrderTime - Specified future order time
* @property {boolean} isSaved - wether the continue clicked by a saved member
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> address information continue. Evid: 812.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from address information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue).

 * comment - Type: string. Desc: comment
 *
 * contactlessDineInInputLabel - Type: string. Desc: User's input label as defined at the settings / null
 *
 * contactlessDineInUOUInput - Type: string. Desc: UoU's input / null
 *
 * curbsideAdditionalInformationContent - Type: string. Desc: string/null
 *
 * curbsidePickupToggle - Type: bool. Desc: true/false
 *
 * delayAlertShown - Type: bool. Desc: true if delay alert is shown (order pacing)
 *
 * dispatchTime - Type: datetime. Desc: delivery/pickup hour
 *
 * dispatchTimeOption - Type: string. Desc: asap/later
 *
 * dispatchType - Type: string. Desc: delivery/pickup/dine-in
 *
 * futureOrderTime - Type: datetime. Desc: Specified future order time
 *
 * isSaved - Type: bool. Desc: wether the continue clicked by a saved member
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {addressInformationContinueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addressInformationContinue = function (params) {
    return { evid: 812, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} smsValidationCancelParams
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} origin - cancel/X/outside
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: SMS validation- cancel. Evid: 839.
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
then clicks on cancel/out of the modal in order to go back to the order..

 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * origin - Type: string. Desc: cancel/X/outside
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {smsValidationCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smsValidationCancel = function (params) {
    return { evid: 839, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} contactInformationContinueValidationErrorParams
* @property {string} errorReason - FirstName/lastName/Email/phone concat between them
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Contact information continue- validation error. Evid: 815.
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Contact information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue).

 * errorReason - Type: string. Desc: FirstName/lastName/Email/phone concat between them
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {contactInformationContinueValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactInformationContinueValidationError = function (params) {
    return { evid: 815, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dashboardAutopilotOloMigrationEndParams
* @property {GUID} instance_id - []
* @property {boolean} isSuccess - true / false
* @property {GUID} locationGuid - []
* @property {GUID} bi_token - []
* @property {string} organization_id - guid
* @property {GUID} site_id - guid
* @property {string} statusAfterMigration - iframe / ooi
**/
/**
 * Name: Dashboard -> Autopilot -> OLO -> Migration End. Evid: 887.
 * Event description: Autopilot finished (iframe to ooi) migration.

 * instance_id - Type: guid. Desc: []
 *
 * isSuccess - Type: bool. Desc: true / false
 *
 * locationGuid - Type: guid. Desc: []
 *
 * bi_token - Type: guid. Desc: []
 *
 * organization_id - Type: string. Desc: guid
 *
 * site_id - Type: guid. Desc: guid
 *
 * statusAfterMigration - Type: string. Desc: iframe / ooi
 * @param {dashboardAutopilotOloMigrationEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAutopilotOloMigrationEnd = function (params) {
    return { evid: 887, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkoutReviewCheckboxParams
* @property {string} lastState - true/false
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Checkout-> Review -> checkbox. Evid: 833.
 * Event description: UoU clicked on the Checkbox in the "Review and Place Order" stage in the checkout..

 * lastState - Type: string. Desc: true/false
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {checkoutReviewCheckboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutReviewCheckbox = function (params) {
    return { evid: 833, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorAppSettingsInteractionParams
* @property {string} appName - App name
* @property {string} category - display/layout/design/info
* @property {string} editMode - desktop / mobile
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - oloSessionid
* @property {string} restaurantId - rest id
* @property {string} subCategory - [sub category, can contain the whole path of sub categories
* @property {string} viewMode - View Mode
**/
/**
 * Name: Editor -> App settings interaction. Evid: 866.
 * Event description: User clicked a button inside app settings.

 * appName - Type: string. Desc: App name
 *
 * category - Type: string. Desc: display/layout/design/info
 *
 * editMode - Type: string. Desc: desktop / mobile
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: oloSessionid
 *
 * restaurantId - Type: string. Desc: rest id
 *
 * subCategory - Type: string. Desc: [sub category, can contain the whole path of sub categories
 *
 * viewMode - Type: string. Desc: View Mode
 * @param {editorAppSettingsInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorAppSettingsInteraction = function (params) {
    return { evid: 866, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} checkboxSaveContactForFutureOrdersParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} restaurantId - organisation ID
* @property {string} value - on/off
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: Checkbox save Contact for future orders. Evid: 853.
 * Event description: OLO- UoU clicked on the checkbox during the checkout (In the Contact info section).

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * value - Type: string. Desc: on/off
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {checkboxSaveContactForFutureOrdersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkboxSaveContactForFutureOrders = function (params) {
    return { evid: 853, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} viewCartParams
* @property {number} abTestSum - always 1
* @property {string} dispatchType - pickup/ delivery
* @property {GUID} locationGuid - null
* @property {number} loyaltyEstimatedEarend - Estimated points about to be earned
* @property {number} totalLoyaltyPoints - Total points, the member has
* @property {number} loyaltyPoints - loyalty points to be redeemed
* @property {number} loyaltyPrice - loyalty points to be redeemed in local currency
* @property {GUID} oloSessionId - session ID
* @property {string} restaurantId - organisation ID
* @property {GUID} rewardId - reward id
* @property {number} totalItemsCount - total items count- the number of items in the cart when clicked
* @property {string} viewMode - Preview/site
**/
/**
 * Name: View Cart. Evid: 803.
 * Event description: OLO- UoU clicked on View cart.

 * abTestSum - Type: numeric. Desc: always 1
 *
 * dispatchType - Type: string. Desc: pickup/ delivery
 *
 * locationGuid - Type: guid.
 *
 * loyaltyEstimatedEarend - Type: numeric. Desc: Estimated points about to be earned
 *
 * totalLoyaltyPoints - Type: numeric. Desc: Total points, the member has
 *
 * loyaltyPoints - Type: numeric. Desc: loyalty points to be redeemed
 *
 * loyaltyPrice - Type: numeric. Desc: loyalty points to be redeemed in local currency
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * rewardId - Type: guid. Desc: reward id
 *
 * totalItemsCount - Type: numeric. Desc: total items count- the number of items in the cart when clicked
 *
 * viewMode - Type: string. Desc: Preview/site
 * @param {viewCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewCart = function (params) {
    return { evid: 803, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} logInSuccessParams
* @property {GUID} locationGuid - location ID
* @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
* @property {string} origin - Origin page, i.e Cart/Checkout/ThankYouPage
* @property {GUID} requestid - request Id to join with log in success
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - preview/editor/etc.
**/
/**
 * Name: log In success. Evid: 848.
 * Event description: OLO- UoU clicked on the log in banner in the Checkout page- with success.

 * locationGuid - Type: guid. Desc: location ID
 *
 * oloSessionId - Type: guid. Desc: Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 *
 * origin - Type: string. Desc: Origin page, i.e Cart/Checkout/ThankYouPage
 *
 * requestid - Type: guid. Desc: request Id to join with log in success
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: preview/editor/etc.
 * @param {logInSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logInSuccess = function (params) {
    return { evid: 848, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} dishModalDishQuantitiesUpdateParams
* @property {string} action - increase (+)/decrease (-)
* @property {string} dishId - dish ID
* @property {GUID} locationGuid - null
* @property {GUID} oloSessionId - session ID
* @property {number} quantity - item count (after the update)
* @property {string} restaurantId - organisation ID
* @property {string} viewMode - Preview/editor
**/
/**
 * Name: Dish Modal -> dish quantities update. Evid: 841.
 * Event description: OLO- In the Dish modal, the UoU clicked on +/- to add/remove the dish' quantity..

 * action - Type: string. Desc: increase (+)/decrease (-)
 *
 * dishId - Type: string. Desc: dish ID
 *
 * locationGuid - Type: guid.
 *
 * oloSessionId - Type: guid. Desc: session ID
 *
 * quantity - Type: numeric. Desc: item count (after the update)
 *
 * restaurantId - Type: string. Desc: organisation ID
 *
 * viewMode - Type: string. Desc: Preview/editor
 * @param {dishModalDishQuantitiesUpdateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dishModalDishQuantitiesUpdate = function (params) {
    return { evid: 841, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} editorToggleOloCtaParams
* @property {GUID} instance_id - {}
* @property {GUID} locationGuid - null
* @property {GUID} bi_token - {}
* @property {GUID} oloSessionId - olo_session_id
* @property {string} restaurantId - rest_id
* @property {string} viewMode - preview/live site
**/
/**
 * Name: Editor -> Toggle OLO CTA. Evid: 844.


 * instance_id - Type: guid. Desc: {}
 *
 * locationGuid - Type: guid.
 *
 * bi_token - Type: guid. Desc: {}
 *
 * oloSessionId - Type: guid. Desc: olo_session_id
 *
 * restaurantId - Type: string. Desc: rest_id
 *
 * viewMode - Type: string. Desc: preview/live site
 * @param {editorToggleOloCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorToggleOloCta = function (params) {
    return { evid: 844, src: 61, endpoint: 'olo-client', params: params };
};
/**
* @typedef {Object} restaurantsOloUouServiceFeeHoverParams
* @property {string} currency - -
* @property {number} feeCount - -
* @property {string} feeIds - all service fee ids
* @property {number} feesAmount - -
* @property {GUID} locationGuid - null
* @property {number} taxAmount - -
* @property {number} taxAndFeesAmount - -
**/
/**
 * Name: Restaurants > OlO > UoU > Service Fee Hover. Evid: 891.
 * Event description: when the uou puts his mouse on the "i" of service fees in the cart.

 * currency - Type: string. Desc: -
 *
 * feeCount - Type: numeric. Desc: -
 *
 * feeIds - Type: string. Desc: all service fee ids
 *
 * feesAmount - Type: numeric. Desc: -
 *
 * locationGuid - Type: guid.
 *
 * taxAmount - Type: numeric. Desc: -
 *
 * taxAndFeesAmount - Type: numeric. Desc: -
 * @param {restaurantsOloUouServiceFeeHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var restaurantsOloUouServiceFeeHover = function (params) {
    return { evid: 891, src: 61, endpoint: 'olo-client', params: params };
};
//# sourceMappingURL=index.js.map